import React from 'react'
import Head from 'next/head'

import SearchPageApp from 'app/SearchPage'
import { getDeviceId } from 'utils/deviceId'

export async function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

export const SearchPage = () => {
  return (
    <>
      <Head>
        <title>Pencarian - Ruang GTK</title>
      </Head>
      <SearchPageApp />
    </>
  )
}

// eslint-disable-next-line react/display-name
SearchPage.Layout = ({ children }) => <>{children}</>

export default SearchPage
